import { useState } from 'react';

import Loading from '../../../../components/loading/Loading';
import { CustomerList } from './CustomerList';
import { Tagged } from '../Tagged';
import { Customer } from '~/lib/api/smartsend/types';
import { P2GLink } from '@parcel2go/core-ui';
import { P2GSidePanel } from '~/components/sidepanel';
import { P2GImageMessage } from '~/components/imagemessage';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

interface props {
  customers: () => Promise<Customer[]>;
  onSelect: (p: Customer) => void;
  text: string;
}
export const CustomerSelector: React.FC<props> = (props) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [customers, setCustomer] = useState<Customer[]>([]);
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  const load = () => {
    setOpen(true);
    setLoading(true);
    props.customers().then((r) => {
      setCustomer(r);
      setLoading(false);
    });
  };

  const onSelect = (p: Customer) => {
    props.onSelect(p);
    setOpen(false);
  };

  if (!props.customers) {
    return null;
  }

  return (
    <>
      <P2GLink onClick={load}>{props.text}</P2GLink>
      <P2GSidePanel
        open={open}
        onClose={() => setOpen(false)}
        anchor="right"
        title={t('CUSTOMERS_SIDEPANEL_TITLE', { defaultValue: 'Customers' })}
      >
        <Tagged tag="panel-customer">
          {loading ? (
            <Loading />
          ) : customers.length === 0 ? (
            <P2GImageMessage
              message={t('NO_RESULT_FALLBACK', { defaultValue: 'No Results' })}
              image="/theme/common/notifications/no-results.png"
              contentKey="image-smartsend-customers-empty-list"
            />
          ) : (
            <CustomerList customers={customers} onSelect={onSelect} />
          )}
        </Tagged>
      </P2GSidePanel>
    </>
  );
};
